<template>
  <v-container fluid class="pa-0">
    <breadcrumbs-banner
      :bannerTitle="$t('header.aboutIncocegla')"
    ></breadcrumbs-banner>
    <v-container class="py-lg-16 pa-10 pa-sm-14 px-lg-3" v-if="aboutUs">
      <v-row>
        <v-col cols="12" lg="6">
          <h3
            class="text-lg-h3 text-h5 text-navy font-weight-bold"
            v-html="aboutUs[0].title"
          ></h3>
          <p
            class="text-navy font-weight-light text-justify mt-lg-5 mr-lg-10"
            v-html="aboutUs[0].description"
          ></p>
        </v-col>
        <v-col cols="12" lg="6">
          <v-img
            :src="aboutUs[0].upload.path"
            class="rounded-lg mt-lg-3"
          ></v-img>
          <p
            class="
              text-gray
              font-weight-light
              text-justify
              mt-lg-5
              mr-lg-10
              text-lg-body-1
            "
            v-html="$t('aboutUs.finalStage')"
          ></p>
        </v-col>
      </v-row>
    </v-container>
    <v-container fluid class="px-lg-0 px-10 pa-sm-14 py-lg-10 background-navy" v-if="aboutUs">
      <v-row class="ma-0">
        <v-container>
          <h4
            class="text-lg-h4 text-white text-center"
            v-html="aboutUs[1].title"
          ></h4>
        </v-container>
      </v-row>
    </v-container>

    <v-container class="py-lg-16 px-lg-3 pa-10 pa-sm-14" v-if="aboutUs">
      <v-row>
        <v-col
          cols="12"
          lg="4"
          v-for="(item, index) in mvv"
          :key="index"
          class="d-flex flex-row"
        >
          <v-card
            class="rounded-lg px-10 py-10 elevation"
            :class="item.background"
            max-height="500"
            min-width="100%"
          >
            <v-img
              :src="item.icon"
              width="100"
              height="100"
              contain
              class="mx-auto"
            ></v-img>
            <v-row class="ma-0 justify-center">
              <h4
                class="text-lg-h4 font-weight-bold mt-5" :class="item.textColor"
                v-html="item.name"
              ></h4>
            </v-row>
            <div
              class="font-weight-light text-lg-justify text-center" :class="item.textColor"
              v-html="item.description"
            ></div>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
    <v-container v-if="aboutUs">
      <v-row class="py-lg-10 flex-column-reverse flex-lg-row mt-10 mt-lg-0">
        <v-col cols="12" lg="6">
          <v-img
            :src="aboutUs[5].upload.path"
            class="rounded-lg mt-lg-3"
          ></v-img>
        </v-col>
        <v-col cols="12" lg="6">
          <h3
            class="
              text-lg-h3 text-h5 text-navy
              font-weight-bold
              ml-lg-10
              mt-lg-5
            "
          >
            {{aboutUs[5].title}}
          </h3>
          <p class="text-navy font-weight-light text-justify mt-lg-5 ml-lg-10" v-html="aboutUs[5].description">
           
          </p>
        </v-col>
      </v-row></v-container
    >
  </v-container>
</template>
<script>
import AboutUsService from "@/services/aboutUs";

export default {
  name: "AboutIncocegla",
  data() {
    return {
      mvv: [],
      aboutUs: null,
    };
  },
  async created() {
    this.aboutUs = await AboutUsService.getAboutUs();
    this.mvv = [
        {
          icon: "/mision.svg",
          name: this.aboutUs[2]?.title,
          description: this.aboutUs[2]?.description,
          background: "background-navy",
          textColor: "text-white"
        },
        {
          icon: "/vision.svg",
          name: this.aboutUs[3]?.title,
          description: this.aboutUs[3]?.description,
          background: "background-odd",
        },
        {
          icon: "/valores.svg",
          name: this.aboutUs[4]?.title,
          description: this.aboutUs[4]?.description,
          background: "background-navy",
          textColor: "text-white"
        },
    ]
  },

};
</script>
